import { c as e, cB as o } from "./ghl-ui.es669.js";
import { fadeInTransition as t } from "./ghl-ui.es1358.js";
import { fadeInScaleUpTransition as i } from "./ghl-ui.es1323.js";
const l = e([o("modal-container", `
 position: fixed;
 left: 0;
 top: 0;
 height: 0;
 width: 0;
 display: flex;
 `), o("modal-mask", `
 position: fixed;
 left: 0;
 right: 0;
 top: 0;
 bottom: 0;
 background-color: rgba(0, 0, 0, .4);
 `, [t({
  enterDuration: ".25s",
  leaveDuration: ".25s",
  enterCubicBezier: "var(--n-bezier-ease-out)",
  leaveCubicBezier: "var(--n-bezier-ease-out)"
})]), o("modal-body-wrapper", `
 position: fixed;
 left: 0;
 right: 0;
 top: 0;
 bottom: 0;
 overflow: visible;
 `, [o("modal-scroll-content", `
 min-height: 100%;
 display: flex;
 position: relative;
 `)]), o("modal", `
 position: relative;
 align-self: center;
 color: var(--n-text-color);
 margin: auto;
 box-shadow: var(--n-box-shadow);
 `, [i({
  duration: ".25s",
  enterScale: ".5"
})])]);
export {
  l as default
};
